/**
 * 本地存储工具
 * @description 提供sessionStorage和localStorage的封装
 */

interface ProxyStorage {
  getItem(key: string): any;
  setItem(Key: string, value: string): void;
  removeItem(key: string): void;
  clear(): void;
}

/**
 * sessionStorage操作类
 */
class sessionStorageProxy implements ProxyStorage {
  protected storage: ProxyStorage;

  constructor(storageModel: ProxyStorage) {
    this.storage = storageModel;
  }

  /**
   * 存储数据
   */
  public setItem(key: string, value: any): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  /**
   * 获取数据
   */
  public getItem(key: string): any {
    return JSON.parse(this.storage.getItem(key));
  }

  /**
   * 删除数据
   */
  public removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  /**
   * 清空数据
   */
  public clear(): void {
    this.storage.clear();
  }
}

/**
 * localStorage操作类
 */
class localStorageProxy extends sessionStorageProxy implements ProxyStorage {
  constructor(localStorage: ProxyStorage) {
    super(localStorage);
  }
}

/**
 * sessionStorage实例
 */
export const storageSession = new sessionStorageProxy(
  typeof window !== 'undefined' ? sessionStorage : ({} as ProxyStorage),
);

/**
 * localStorage实例
 */
export const storageLocal = new localStorageProxy(
  typeof window !== 'undefined' ? localStorage : ({} as ProxyStorage),
);
